import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Button, Input } from "reactstrap";
import RequiredField, { FirstName, LastName, Submit, Cancel,BirthDate, Age,MobileNo,AadharNumber, Gender,Address, Department, Password, ConfirmPassword} from "../../../Constant";
import { Breadcrumbs } from "../../../AbstractElements";
import { useLocation, useNavigate } from "react-router";
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { CreateInventory, InventoryCategoryList, UpdateInventory } from "../../../apiController";


const InventoryForm = ({ setSteps }) => {
  const navigate = useNavigate()

  const location = useLocation();

  const { rowData } = location.state || {};

  const [inventoryCategory, setInventoryCategory] = useState([]);
  const [formdata, setFormdata] = useState({inventorycategory: rowData?.category_id, status: rowData&&rowData.condition_status?rowData.condition_status:"",});

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm();

  useEffect(()=>{
    if(rowData){
      setValue('inventorycategory', rowData?.category_id)
      setValue('status', rowData?.condition_status)
    }
  },[])




  // const handleCategoryChange = (event) => {
  //   const { name, value } = event.target;
  //   setFormdata({ ...formdata, [name]: value });
  // };



  const onSubmit = async (data) => {
    console.warn(data)
    setFormdata((prev) => ({ ...prev, ...data }));
    // setSteps((prev) => prev + 1);
    console.log(register)
    const formattedData = {
      category_id: data.inventorycategory,
      material_name: data.materialname,
      make: data.make,
      stock_in: data.stockquantity,
      stock_out: data.stockout,
      condition_status:data.status,
      id: rowData? rowData.id : ""
    }

    try {
      if (rowData) {
          const response = await UpdateInventory(formattedData);
          if (response.status === true) {
              toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
          }
          navigate(`${process.env.PUBLIC_URL}/inventory/:layout>}`)
      } else {
          const response = await CreateInventory(formattedData);
          if (response.status === true) {
              toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
              
          }
          navigate(`${process.env.PUBLIC_URL}/inventory/:layout>}`)
      }
  } catch (error) {
      toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
  }
    reset()
    
  };

  const fetchInventoryCategory = async () => {
    const response = await InventoryCategoryList();
    if (response.status === true) {
      setInventoryCategory(response.data);
    }
  };

  useEffect(()=>{
    fetchInventoryCategory()
  },[])

  return (
    <Fragment>
      <Breadcrumbs parent="Inventory" mainTitle="Inventory Form" title="Inventory Form" />
          <Form onSubmit={handleSubmit(onSubmit)} className="form-bookmark needs-validation">
      <Row>
        <Col sm="1" lg="2" xl="3"></Col>
        <Col sm="10" lg="8" xl="6" className="custom-padding-lg">
        <FormGroup className="mb-3">
                                    <Label htmlFor="exampleFormControlSelect9">{"Inventory Category"} <RequiredField/></Label>
                                    <select name="pharmacycategory" className="form-control digits" id="inventorycategory" value={formdata.inventorycategory} {...register("inventorycategory", { required: true })} >
                                    <option  value=''>Select Inventory Category</option>
                                    {inventoryCategory.map((type)=> <option key={type.id} value={type.id}>{type.name}</option>)}
                                    </select>
                                    <span className="text-danger">{errors.inventorycategory && "Inventory Category is required"}</span>
                                </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Material Name"} <RequiredField/></Label>
              <input className={`form-control ${errors.materialname && "is-invalid"}`} id="materialname" type="text" name="materialname" defaultValue={formdata.materialname || rowData?.material_name} {...register("materialname", { required: true })} />
              <span className="text-danger">{errors.make && "Material Name is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Make"} <RequiredField/></Label>
              <input className={`form-control ${errors.make && "is-invalid"}`} id="make" type="text" name="make" defaultValue={formdata.make || rowData?.make} {...register("make", { required: true })} />
              <span className="text-danger">{errors.make && "Make is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="mobilenumber">{"Stock Quantity"} <RequiredField/></Label>
              <input className={`form-control ${errors.stockquantity && "is-invalid"}`} id="stockquantity" type="number" name="stockquantity" defaultValue={formdata.stockquantity || rowData?.stock_in} {...register("stockquantity", { required: true })} />
              <span className="text-danger">{errors.stockquantity && "Stock Quantity is required"}</span>
            </FormGroup>
            {rowData && <FormGroup className="mb-3">
              <Label htmlFor="mobilenumber">{"Stock Out"} <RequiredField/></Label>
              <input className={`form-control ${errors.stockout && "is-invalid"}`} id="stockout" type="number" name="stockout" defaultValue={formdata.stockout || rowData?.stock_out} {...register("stockout", { required: false })} />
              <span className="text-danger">{errors.stockout && "Stock Out is required"}</span>
            </FormGroup>}
           { rowData?.category_name === 'Instruments' && <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Status"} <RequiredField/></Label>
              <select className={`form-control ${errors.status && "is-invalid"}`} id="status" type="text" name="status"  {...register("status", { required: false })} >
              <option value="">Select Condition Status</option>
              <option value="Good">Good</option>
                                  <option value="Fair">Fair</option>
                                  <option value="Poor">Poor</option>
                                  <option value="Defective">Defective</option>
              </select>
              <span className="text-danger">{errors.status && "Status is required"}</span>
            </FormGroup>}
            <div className="text-end btn-mb mt-5">
              <Button className="secondary me-2" onClick={()=> navigate(`${process.env.PUBLIC_URL}/inventory/:layout>}`)}>
                {Cancel}
              </Button>
            <Button className="primary" type="submit">
                {Submit}
              </Button>
            </div>                              
            </Col>
            <Col sm="1" lg="2" xl="3"></Col>
      </Row>
          </Form>
    </Fragment>
  );
};

export default InventoryForm;
